import { ChangeDetectionStrategy, Component, HostListener, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { BasicDialogData } from '@app/shared/types/models/shared/confirmation-dialog.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';

@Component({
  selector: 'proffeo-information-dialog',
  imports: [UiDialogComponent, MatDialogModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './information-dialog.component.html'
})
export class InformationDialogComponent implements OnInit {
  private readonly dialogData: BasicDialogData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef: MatDialogRef<InformationDialogComponent> = inject(
    MatDialogRef<InformationDialogComponent>
  );

  protected title: string;
  protected desc: string;

  @HostListener('keydown.esc', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  protected onEsc($event: KeyboardEvent): void {
    $event.stopPropagation();
    this.close();
  }

  public ngOnInit(): void {
    this.title = this.dialogData.title;
    this.desc = this.dialogData.desc;
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
